import { render, staticRenderFns } from "./Gastos.vue?vue&type=template&id=fe739c9c&scoped=true&"
import script from "./Gastos.vue?vue&type=script&lang=js&"
export * from "./Gastos.vue?vue&type=script&lang=js&"
import style0 from "./Gastos.vue?vue&type=style&index=0&id=fe739c9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe739c9c",
  null
  
)

export default component.exports